<ng-container *transloco="let t">
  <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <div class="modal-header">
      <h2 class="modal-title">{{ t('portfolio/renameFile/title') }}</h2>
      <button type="button" (click)="activeModal.dismiss()" aria-label="Close" class="btn-close"></button>
    </div>
    <div class="modal-body">
      <label for="renameFileInput" class="form-label">{{ t('portfolio/renameFile/label') }}</label>
      <div class="input-group has-validation">
        <input
          id="renameFileInput"
          type="text"
          class="form-control"
          autocomplete="off"
          ngbAutofocus
          [formControl]="control"
          [class.is-invalid]="control.invalid && (control.dirty || control.touched)"
        />
        <span *ngIf="extension" class="input-group-text">{{ extension }}</span>
        <div class="invalid-feedback" *ngIf="control.errors?.['required']">{{ t('portfolio/renameFile/requiredError') }}</div>
        <div class="invalid-feedback" *ngIf="control.errors?.['maxlength']">
          {{ t('portfolio/renameFile/maxLengthError', { maxLength: maxLength }) }}
        </div>
        <div class="invalid-feedback" *ngIf="control.errors?.['forbiddenChars']">
          {{ t('portfolio/renameFile/forbiddenCharsError', { chars: forbiddenChars }) }}
        </div>
      </div>
      <div *ngIf="extension" class="form-text">{{ t('portfolio/renameFile/extensionHint') }}</div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary" (click)="activeModal.dismiss()">{{ t('portfolio/renameFile/cancel') }}</button>
      <button type="submit" class="btn btn-primary">{{ t('portfolio/renameFile/save') }}</button>
    </div>
  </form>
</ng-container>
